import React from 'react';

export const networkError = () => {
  return (
    <div>
      It appears there is an issue with your network or firewall configuration
      blocking you from connecting to the RapidSOS platform. Please validate
      that your network/firewall configuration allows access to the following
      domains: rapidsosportal.com
      <ul>
        <li>rapidsosportal.com</li>
        <li>api.rapidsos.com</li>
        <li>cdn.rapidsos.com</li>
        <li>google.com</li>
        <li>googleapi.com</li>
        <li>sentry.io</li>
        <li>www.google.com/recaptcha/api.js</li>
        <li>www.google-analytics.com</li>
        <li>www.googletagmanager.com</li>
        <li>rapidsos.zendesk.com</li>
      </ul>
      If the problem persists, please submit a support request with the form
      below for assistance.
    </div>
  );
};

export const configError = () => {
  return `It appears there is a configuration issue with
    your RapidSOS platform integration. Please
    submit a support request with the form below
    for assistance.`;
};

export const authorizationError = () => {
  return `It appears your integration credentials do not have proper
    access to the required RapidSOS platform services.
    Please submit a support request with the form below for
    assistance.`;
};

export const locationError = () => {
  return `It appears your authority’s geofence may be misconfigured
    for your area. Please review your currently approved geofence
    coverage region in RapidSOS Portal and  submit a support
    request with the form below for assistance.`;
};

export const hermesError = () => {
  return `It appears there is an issue with your network or firewall
    configuration blocking you from connecting to the RapidSOS platform.
    Please verify that you do not have any settings disallowing long-standing connections.
    If the problem persists, please submit a support request with the form below
    for assistance.`;
};
